import React, { useEffect } from 'react';
import { Notifications } from './components/Notifications';
import { Main } from './components/layout/Main';
import { RemoveKendoReactWatermarks } from './app/RemoveKendoReactWatermarks';
import CookieConsent from "react-cookie-consent";
import { Button } from "@progress/kendo-react-buttons";

import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faUser,
    faUsers,
    faHouseUser,
    faCog,
    faSignOutAlt,
    faLandmark,
    faBell,
    faCalendarDays,
    faClock,
    faMicrophone,
    faFileCsv,
} from '@fortawesome/free-solid-svg-icons';

import './_theme.scss';
import './_app.scss';

library.add(
    faUser,
    faUsers,
    faHouseUser,    
    faCog,    
    faSignOutAlt,    
    faLandmark,
    faBell,
    faCalendarDays,
    faClock,
    faMicrophone,
    faFileCsv,
);

const App = () => {
    useEffect(() => {
        setTimeout(() => {
            RemoveKendoReactWatermarks();
        }, 50);
    }, []);

    return (
        <>
            <Notifications />
            <CookieConsent
                location="bottom"
                disableStyles={true}
                containerClasses="cookieConsent"
                contentClasses="cookieConsentContent"
                buttonWrapperClasses="cookieConsentButton"
                buttonClasses="k-button k-button-solid-primary"
                ButtonComponent={Button}
            >
                This website uses cookies to enhance the user experience.
            </CookieConsent>
            <Main />
        </>
    );
}

export default App;